import { eternityChallenges } from "./eternity-challenges";
import { infinityChallenges } from "./infinity-challenges";
import { normalChallenges } from "./normal-challenges";

export const challenges = {
  normal: normalChallenges,
  infinity: infinityChallenges,
  eternity: eternityChallenges,
};
